import React from 'react'
import './menu.scss'
import LoginComponent from './components/Login';


class Menu extends React.Component {
    render() {
        return (
            <header className="Menu">
                <img className="logo" src="/resources/Logo.svg" alt="Lingui" />
                <LoginComponent />
            </header>
        );
    }
}

export default Menu;